import React, { useEffect, useRef, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { MultiSelect, useMultiSelect } from '../multiSelect';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import SearchBar from '../searchBar';
import SearchIcon from '@mui/icons-material/Search';
import Action from './Action';
import styles from './styles.module.css';
import PredefinedViewsButton from './PredefinedViewsButton';

export function useToolbar(initialData, defaultSelectedColumns) {
  const [rows, setRows] = useState(initialData);

  const { selection: selectedElement, handleInputChange: handleSelectedElement } = useMultiSelect(defaultSelectedColumns, true, () => {});

  return {
    rows,
    setRows,
    selectedElement,
    handleSelectedElement,
  };
}

export function ToolBar(props) {
  const {
    selection,
    handleDownload,
    download,
    searchable,
    searchPlaceHolder,
    filters = false,
    selectedData = [],
    actionButtons = [],
    onSearch,
    initialText = '',
    currentView,
    onViewChange,
    onOpenColumnsMenu,
    showPredefinedViewsButton = false,
  } = props;

  const [searchText, setSearchText] = useState(initialText);
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    setSearchText(initialText || '');
  }, [initialText]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const requestSearch = (searchedVal) => {
    setSearchText(searchedVal);

    const value = (searchedVal || '').trim();

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = null;
    }

    if (value.length >= 1) {
      searchTimeoutRef.current = setTimeout(() => {
        onSearch(value);
        searchTimeoutRef.current = null;
      }, 1000);
    } else {
      onSearch('');
    }
  };

  const cancelSearch = () => {
    setSearchText('');
    onSearch('');

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = null;
    }
  };

  return (
    <>
      <Grid container style={{ marginBottom: '25px' }} spacing={2} alignItems="center">
        <Grid item xs={6}>
          {searchable && (
            <SearchBar
              value={searchText}
              placeholder={searchPlaceHolder}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={cancelSearch}
              searchIcon={<SearchIcon style={{ position: 'absolute', right: 0, color: 'black', fontSize: '20px' }} />}
              style={{
                width: '100%',
                height: '56px',
                borderRadius: '0px',
                border: 'solid #efefef',
                borderWidth: '2px',
              }}
            />
          )}
        </Grid>

        <Grid item xs={6}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: '12px',
              flexWrap: 'nowrap',
              width: '100%',
            }}
          >
            {actionButtons.map((actionButton) => (
              <Action key={actionButton.title} actionButton={actionButton} selectedData={selectedData} />
            ))}

            {download && !filters && (
              <Button className={styles.button} style={{ color: '#6200EE' }} onClick={handleDownload} startIcon={<DownloadOutlinedIcon />}>
                {'Télécharger'}
              </Button>
            )}
          </div>
        </Grid>
      </Grid>

      {filters && (
        <Grid container direction="row" alignItems="center" style={{ justifyContent: 'flex-end' }}>
          {showPredefinedViewsButton && (
            <Grid item xs={4}>
              <PredefinedViewsButton currentView={currentView} onChange={onViewChange} />
            </Grid>
          )}
          <Grid item xs={3}>
            <MultiSelect label={'CHOISIR COLONNES'} value={selection} onOpen={onOpenColumnsMenu} iconColor={'#6200EE'} />
          </Grid>
          {download && (
            <Grid item xs={2}>
              <Button
                className={styles.button}
                style={{ color: '#6200EE', fontFamily: 'canalfont-regular' }}
                onClick={handleDownload}
                startIcon={<DownloadOutlinedIcon />}
              >
                {'Télécharger'}
              </Button>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
}

export default ToolBar;
